// src/firebase1.ts (Oyun 1)
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
    apiKey: "AIzaSyD5WRE2JIeLvxttdwQKtNxeNO6LAW52qPU",
    authDomain: "astroad-f64e2.firebaseapp.com",
    projectId: "astroad-f64e2",
    storageBucket: "astroad-f64e2.firebasestorage.app",
    messagingSenderId: "631943400577",
    appId: "1:631943400577:web:c168d17b4c94e93539d180",
};

const app = initializeApp(firebaseConfig, "astroad"); // Her oyun için benzersiz bir isim
export const db4 = getFirestore(app);